import axios from 'axios';
import {
  DeleteFileDocumentAction,
  GenerateORSRFileAction,
  GenerateRefundAction,
  StoreAction,
  UpdateNoteAction,
  UpdateOrderStatusAction,
  UploadNewDocumentAction,
  UploadSignedFileAdminAction
} from '../../../app/ActionsImpl';
import { StyledDocumentItem } from '../../document-download/DocumentDownload.styled';
import { DocumentItem } from './DocumentsList.atoms';

import { CloseOutlined, EditOutlined, PlusCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Card, Checkbox, Col, Form, Input, Row, Spin, Tooltip } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import Modal from 'antd/lib/modal/Modal';
import { saveAs } from 'file-saver';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Dispatch } from 'redux';
import { Segment } from 'semantic-ui-react';
import { getFlow } from '../../../api/admin.api';
import { AppState } from '../../../app/AppState';
import { FileToUpload } from '../../../app/RequestInterfaces';
import { COMPANY_LOOKUP_HOST } from '../../../constants';
import DitecSigner from '../../../utils/DitecSigner';
import { OrderStatusModal } from '../../frontoffice/components/OrderStatusModal';
import { OrderState, ORSRFileTypes, PaidStatus, UploadsStatus } from '../pages/Interfaces';
import OrderItemUploadIconsComponent from './OrderItemUploadIconsComponent';
import RefundOverview from './RefundOverview';

interface DocumentItem {
  name: any;
  link: any;
  uploads?: any;
  uploadsStatus: UploadsStatus;
}

export interface Props extends StateProps, DispatchProps {
  data: { id: string } & any;
  token: any;
  refresh: () => void;
}

function OrderItem({
  user,
  data,
  fileUpload,
  fileDelete,
  token,
  refresh,
  saveNote,
  saveOrderStatus,
  generateORSRFile,
  generateRefund,
  uploadSignedFile
}: Props) {
  const [showDetail, setShowDetail] = useState(false);
  const [activeTab, setActiveTab] = useState('contact');
  const [showOrderStatus, setShowOrderStatus] = useState(false);
  const [note, setNote] = React.useState('');
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(false);
  const [formState, setFormState] = useState<any>({});
  const [zivnosti, setZivnosti] = useState<any>([]);
  const [modalVisible, setModalVisible] = useState<any>(false);
  const [refundForm, setRefundForm] = useState<any>({ zivnosti: {}, amount: 0 });
  const [loading, setLoading] = useState<any>(false);
  const [isCreate, setIsCreate] = useState(false)
  const [isChange, setIsChange] = useState(false)
  const [formData, setFormData] = useState<any>({});

  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const history = useHistory();

  const toogleNav = (index: string) => {
    setActiveTab(index)
  };

  useEffect(() => {
    if (!data) return;
  
    const parsedFormState = data?.formState ? JSON.parse(data.formState) : {};
  
    let stepWithAddress = Object.values(parsedFormState).find(
      (item: any) => typeof item === 'object' && item?.type === 'ownerCompany' && item?.name
    ) as any;
  
    if (!stepWithAddress) {
      stepWithAddress = Object.values(parsedFormState).find(
        (item: any) => typeof item === 'object' && item?.type === 'ownerPerson'
      ) as any;
    }
  
    const address = stepWithAddress?.address || {};
  
    const kontaktMeno = stepWithAddress?.separatedName
      ? `${stepWithAddress.separatedName.name || ''} ${stepWithAddress.separatedName.surname || ''}`.trim()
      : '';
  
    const customerDefaults = {
      name: `${user?.attributes?.given_name || ''} ${user?.attributes?.family_name || ''}`.trim(),
      email: user?.attributes?.email || '',
      country: address.country || parsedFormState.country || 'Slovenská republika',
      personType: parsedFormState.personType || 'ownerPerson',
    };
  
    const combinedData = {
      ...customerDefaults,
      ...parsedFormState,
      ...data.formData,
      spolocnost: stepWithAddress?.name || '',
      kontakt_meno: kontaktMeno,
      line1: address.street && address.number ? `${address.street} ${address.number}` : address.street || '',
      city: address.city || '',
      postal_code: address.zip || '',
    };
  
    combinedData.adresa = (combinedData.line1 || combinedData.postal_code || combinedData.city)
      ? `${combinedData.line1 || ''}, ${combinedData.postal_code || ''} ${combinedData.city || ''}, ${combinedData.country || ''}`.trim()
      : '';
  
    setFormData(combinedData);
    setFormState(parsedFormState);
  }, [data, user]);  

  const onFlow = (flow: any) => {
    if (flow.document.metadata.title.indexOf('Založenie') > -1) {
      setIsCreate(true)
    }
    if (flow.document.metadata.title.indexOf('Zmeny') > -1) {
      setIsChange(true)
    }
  }

  useEffect(() => {
    setNote(data.note);
  }, [data]);

  useEffect(() => {
    if (formState) {
      let newZivnosti: any = [];
      let parsedValues = formState;
      setZivnosti(data.formData.zivnosti);
    }
  }, [formState])

  const handleTriggerDownload = async (documentItem: any, id: any) => {
    const filename = documentItem.name;
    await axios
      .get(
        `${COMPANY_LOOKUP_HOST}/order/download-file-admin/${id}/${documentItem.id}`,
        {
          responseType: 'blob',
        },
      ).then((res) => {
        saveAs(res.data, filename);
      });
  };

  const isUploadsActive = () =>
    user.signInUserSession.accessToken.payload['cognito:groups']
      .indexOf('admin',) !== -1;

  const handleFileDelete = async (orderId: string, documentIndex: number) => {
    setDeleteButtonDisabled(true);
    await fileDelete(orderId, documentIndex.toString())
    await refresh()
    setDeleteButtonDisabled(false)
  }

  const handleTriggerRefundDownload = async (documentItem: any, id: any) => {
    const filename = documentItem.name;
    await axios
      .get(
        `${COMPANY_LOOKUP_HOST}/order/download-refund-admin/${data._id}/${id}/${documentItem.id}`,
        {
          responseType: 'blob',
        },
      ).then((res) => {
        saveAs(res.data, filename);
      });
  };
  const handleFileChange = async (event: any) => {
    let files2Upload: any[] = [];
    for (let oneFile of event.target.files) {
      let reader = new FileReader()
      reader.onload = async (loadEvent: any) => {
        let tmp1 = {
          name: oneFile.name,
          content: reader.result
        }
        files2Upload.push(tmp1)
        if (files2Upload.length === event.target.files.length) {
          await fileUpload(data._id, files2Upload);
          await refresh();
          event.target.value = ''
        }
      }

      await reader.readAsDataURL(oneFile)
    }
  }

  const textarea = Array.from(document.querySelectorAll('textarea'));
  if (textarea) {
    textarea.map((area) => {
      area.addEventListener('focus', (e: any) => {
        area.style.height = '65px';
        let scHeight = e.target.scrollHeight;
        area.style.height = `${scHeight}px`;
      });
      area.addEventListener('blur', (e: any) => {
        area.style.height = '63px';
      });
    });
  }

  const handleStatusModalClose = async () => {
    setShowOrderStatus(false);
    await refresh();
  }

  const generateORSRFileComponent = async (orderId: any, fileType: ORSRFileTypes) => {
    generateORSRFile(orderId, fileType);
  }

  const downloadORSRFile = async (orderId: any, fileType: ORSRFileTypes) => {
    await axios
      .get(
        `${COMPANY_LOOKUP_HOST}/order/download-file-orsr/${fileType}/${orderId}`,
        {
          responseType: 'blob',
        },
      ).then((res) => {
        saveAs(res.data, fileType + '-generovane.xml');
      });
  }


  const setRefund = (e: any) => {
    let newRefundForm = refundForm
    if (e.target.checked) {
      newRefundForm.amount += e.target.name === "representationPrice" ? (data.formData[e.target.name] * 1.2) : data.formData[e.target.name]
      newRefundForm[e.target.name] = data.formData[e.target.name]
    } else {
      newRefundForm.amount -= e.target.name === "representationPrice" ? (data.formData[e.target.name] * 1.2) : data.formData[e.target.name]
      delete newRefundForm[e.target.name]
    }
    setRefundForm(newRefundForm)
    forceUpdate()
  }

  const setRefundCrafts = (index: any, craft: any) => {
    let newRefundForm = refundForm
    if (newRefundForm.zivnosti[index]) {
      newRefundForm.amount -= craft.price
      delete newRefundForm.zivnosti[index]
    } else {
      newRefundForm.amount += craft.price
      newRefundForm.zivnosti[index] = craft
    }
    setRefundForm(newRefundForm)
    forceUpdate()
  }

  const callbackFunction = async (response: any) => {
    console.log("callback", response)
    await uploadSignedFile(response.orderId, response.fileId, response)
    await refresh()
    // let zip = new JSZip();
    // await zip.loadAsync(response.signedContainer, { base64: true });
    // let blob = await zip.generateAsync({ type: "blob" });

    // let element = document.createElement("a");
    // element.setAttribute("href", window.URL.createObjectURL(blob));
    // element.setAttribute("download", "file.asice");
    // element.style.display = "none";
    // document.body.appendChild(element);
    // element.click();
    // document.body.removeChild(element);
  }

  const errorFunction = (error: any) => {
    console.log("callback", error)
  }

  const signFile = async (documentItem: any, id: any) => {
    const filename = documentItem.name;
    if (documentItem.signedFile && documentItem.signedFile.key) {
      axios
        .get(
          `${COMPANY_LOOKUP_HOST}/order/download-file-admin/${id}/${documentItem.signedFile.id}`,
          {
            responseType: 'arraybuffer',
          },
        )
        .then((res) => {
          let base64data = Buffer.from(res.data, 'binary').toString('base64');
          console.log(base64data);
          let dsigner = new DitecSigner(callbackFunction, errorFunction);
          dsigner.asicAddSignature(base64data, filename, id, documentItem.id);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      axios
        .get(
          `${COMPANY_LOOKUP_HOST}/order/download-file-admin/${id}/${documentItem.id}`,
          {
            responseType: 'arraybuffer',
          },
        )
        .then((res) => {
          let base64data = Buffer.from(res.data, 'binary').toString('base64');
          console.log(base64data);
          let dsigner = new DitecSigner(callbackFunction, errorFunction);
          dsigner.signFile(base64data, filename, id, documentItem.id);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  return (
    <Card className={showDetail ? 'orderListCardContainer active' : 'orderListCardContainer'}>
      <div className="ordersInfoStatus" onClick={() => setShowDetail(!showDetail)}>
        <h4>
          {/* {` ${data.formData?.kontakt_meno || '??'} (${(formState.companyName ? formState.companyName : ((formState.company) ? formState.company.name : data.formData.spolocnost))})`} */}
          {data.formData?.kontakt_email ? data.formData?.kontakt_email : 'Nevyplnené'}<br />
          {data.documentName ? data.documentName : 'Nevyplnené'}
        </h4>
        <span className='orderListDate'>{new Date(data.updated_at).toLocaleString()} </span>
        <span><strong style={{ color: data.status === 'unpaid' ? '#f00' : '#0077b6' }}>{PaidStatus[data.status as keyof typeof PaidStatus]}</strong></span>
        <Tooltip title="Upraviť objednávku">
          <EditOutlined onClick={() => { window.open("/admin-flow/" + data.flow_id + "?order=" + data._id + "&steps=" + data.steps.steps, "_blank") }} />
        </Tooltip>
        <Button
          className="addButton"
          disabled={data.status === 'unpaid'}
          onClick={() => setShowOrderStatus(!showOrderStatus)}>
          Stav objednávky:{' '}
          {data.orderStatus?.actualStatus?.state
            ? data.orderStatus.actualStatus.state
            : OrderState.VYTVORENE}
        </Button>
      </div>
      <div className='orderListNoteContainer'>
        <Form.Item label="Poznámka" className='ordersTextareaContainer'>
          <TextArea
            className="ordersTextarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}></TextArea>
        </Form.Item>
        <Tooltip title="Uložiť poznámku">
          <SaveOutlined onClick={() => saveNote(note, data._id)} />
        </Tooltip>
      </div>
      {showDetail &&
        <>
          <Segment className='ordersTabNavigation'>
            <div className="ordersButtonGroup">
              <Button className={activeTab === 'contact' ? 'active contact' : 'contact'} onClick={() => toogleNav('contact')}>Kontakt</Button>
              <Button className={activeTab === 'documents' ? 'active documents' : 'documents'} onClick={() => toogleNav('documents')}>Dokumenty</Button>
              <Button className={activeTab === 'more' ? 'active more' : 'more'} onClick={() => toogleNav('more')}>Viac</Button>
            </div>
          </Segment>

          {activeTab === 'contact' && (
            <Card>
              <b style={{ fontSize: 17, marginBottom: 15, display: 'block' }}>
                Kontakt:
              </b>
              <Form className="orderFormLayout">
                <Row>
                  <Col span={12}>
                    <Form.Item label="Spoločnosť">
                      <Input
                        value={
                          !formData.spolocnost
                            ? 'Nevyplnené'
                            : formData.spolocnost
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Adresa">
                      <Input
                        value={
                          !formData.adresa ? 'Nevyplnené' : formData.adresa
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="IČO">
                      <Input
                        value={!data.formData.ico ? 'Nevyplnené' : data.formData.ico}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="DIČ">
                      <Input
                        value={!data.formData.dic ? 'Nevyplnené' : data.formData.dic}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="ICDPH">
                      <Input
                        value={!data.formData.icdph ? 'Nevyplnené' : data.formData.icdph}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Kontakt_meno">
                      <Input
                        value={
                          !formData.kontakt_meno
                            ? 'Nevyplnené'
                            : formData.kontakt_meno
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Kontakt_email">
                      <Input
                        value={
                          !data.formData.kontakt_email
                            ? 'Nevyplnené'
                            : data.formData.kontakt_email
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Kontakt_phone">
                      <Input
                        value={
                          !data.formData.kontakt_phone
                            ? 'Nevyplnené'
                            : data.formData.kontakt_phone
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          )}

          {activeTab === 'more' && (
            <>
              <Card>
                <div className='fuzsButtonsContainer'>
                  {isChange && (
                    <>
                      <Button className="addButton" onClick={() => generateORSRFileComponent(data._id, ORSRFileTypes.FUZS)}>
                        Generuj FUZS súbor
                      </Button>
                      <Button className="addButton" onClick={() => downloadORSRFile(data._id, ORSRFileTypes.FUZS)}>
                        Stiahni FUZS súbor
                      </Button>
                    </>
                  )}
                  {isCreate && (
                    <>
                      <Button className="addButton" onClick={() => generateORSRFileComponent(data._id, ORSRFileTypes.FUPS)}>
                        Generuj FUPS súbor
                      </Button>
                      <Button className="addButton" onClick={() => downloadORSRFile(data._id, ORSRFileTypes.FUPS)}>
                        Stiahni FUPS súbor
                      </Button>
                    </>
                  )}
                </div>
                <div className='dobropisContainer'>
                  <h4>Dobropisy:</h4>
                  {data.refunds && Object.entries<any>(data.refunds).map(([key, refund]) => {
                    return (
                      refund.map((documentItem: any, documentIndex: number) => {
                        if (!documentItem) {
                          return null;
                        }
                        const { name } = documentItem;
                        return (
                          <StyledDocumentItem key={`doc-downloadn-${name}`}>
                            <div className="ordersDatabaseRow">
                              <Row style={{ alignItems: 'center' }}>
                                <Col span={8}>
                                  <b>{name}</b>
                                </Col>
                                <Col span={11}>

                                </Col>
                                <RefundOverview
                                  orderId={data._id}
                                  documentItem={documentItem}
                                  documentId={key}
                                  token={token}
                                />
                                <Col span={3}>
                                  <Button
                                    onClick={() => handleTriggerRefundDownload(documentItem, key)}
                                    size="large"
                                    type="primary">
                                    Stiahnuť
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          </StyledDocumentItem>
                        );
                      })
                    )
                  }
                  )}
                </div>
                <Button
                  className="addButton"
                  disabled={data.status === 'unpaid'}
                  onClick={async () => setModalVisible(true)}>
                  Vystaviť dobropis
                </Button>
              </Card>
              {zivnosti && zivnosti.length > 0 &&
                <Card>
                  <b style={{ fontSize: 17, marginBottom: 15, display: 'block' }}>
                    Živnosti:
                  </b>
                  <Form className="orderFormLayout">
                    {zivnosti.map((zivnost: any) => {
                      return (
                        <Row>
                          <Col span={24}>
                            <Form.Item label={zivnost.type}>
                              {zivnost.name}
                            </Form.Item>
                          </Col>
                        </Row>
                      )
                    })}
                  </Form>
                </Card>
              }
              <Modal
                style={{ minWidth: '60%' }}
                onCancel={() => {
                  setModalVisible(false)
                  setRefundForm({ zivnosti: {}, amount: 0 })
                }}
                onOk={async () => {
                  setLoading(true)
                  await generateRefund(data._id, refundForm)
                  await refresh();
                  setRefundForm({ zivnosti: {}, amount: 0 })
                  setLoading(false)
                  setModalVisible(false)
                }}
                visible={modalVisible}
              >
                <Spin spinning={loading} size="large" >
                  <h1>Vyberte položky</h1>
                  <br />
                  <br />
                  <div
                    style={{
                      maxWidth: '90%',
                      height: 'auto',
                      breakAfter: 'always',
                      whiteSpace: 'pre-wrap',
                    }}>
                  </div>
                  <Form className="orderFormLayout">
                    <Row>
                      <Col span={24}>
                        <Checkbox
                          name="courtFee"
                          checked={refundForm.courtFee !== undefined}
                          style={{ marginRight: 'auto' }}
                          onClick={setRefund}
                        >
                          <Form.Item label={"Súdny poplatok"}>
                            {data.formData.courtFee}EUR
                          </Form.Item>
                        </Checkbox>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <Checkbox
                          name="representationPrice"
                          checked={refundForm.representationPrice !== undefined}
                          onClick={setRefund}
                          style={{ marginRight: 'auto' }}>
                          <Form.Item label={"Poplatok za zastupovanie"}>
                            {data.formData.representationPrice * 1.2}EUR s DPH
                          </Form.Item>
                        </Checkbox>
                      </Col>
                    </Row>
                    {Array.isArray(zivnosti) && zivnosti.map((zivnost: any, index: number) => (
                      <Row key={index}>
                        <Col span={24}>
                          <Checkbox
                            checked={refundForm?.zivnosti?.[index] !== undefined}
                            onClick={() => setRefundCrafts(index, zivnost)}
                            style={{ marginRight: 'auto' }}
                          >
                            <Form.Item label={zivnost?.type || 'Neznámy typ'}>
                              {zivnost?.name || 'Neznáma živnosť'} - {zivnost?.price || 0}EUR
                            </Form.Item>
                          </Checkbox>
                        </Col>
                      </Row>
                    ))}
                    <Row>
                      <Col span={24}>
                        <Form.Item label={"SPOLU"}>
                          {refundForm.amount}EUR
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </Spin>
              </Modal>
            </>
          )
          }
          {activeTab === 'documents' && (
            <Card>
              {data.downloads?.map((documentItem: any, documentIndex: number) => {
                if (!documentItem) {
                  return null;
                }
                const { name, uploads, uploadsStatus, signedFile } = documentItem;
                return (
                  <StyledDocumentItem key={`doc-downloadn-${name}`}>
                    <div className="ordersDatabaseRow">
                      <Row style={{ alignItems: 'center' }}>
                        <Col span={8}>
                          <b>{name}</b>
                        </Col>
                        <Col span={1}>
                          {documentItem.custom && (
                            <span className="orderItemUploadIcons">
                              <CloseOutlined
                                className="delete"
                                onClick={() => handleFileDelete(data._id, documentIndex)}
                                disabled={deleteButtonDisabled}
                                hidden={!isUploadsActive()}
                              />
                            </span>
                          )}
                        </Col>
                        <Col span={3}>
                          <Button
                            onClick={() => handleTriggerDownload(documentItem, data._id)}
                            size="small"
                            type="primary">
                            PDF
                          </Button>
                          {signedFile &&
                            <Button
                              onClick={() => handleTriggerDownload(signedFile, data._id)}
                              size="small"
                              type="primary">
                              ASICe
                            </Button>
                          }
                          <Button
                            onClick={() => signFile(documentItem, data._id)}
                            size="small"
                            type="primary">
                            Podpísať
                          </Button>
                        </Col>
                        {/* <Col span={8}> */}
                        <OrderItemUploadIconsComponent
                          orderId={data._id}
                          documentIndex={documentIndex.toString()}
                          uploads={uploads}
                          refresh={refresh}
                          documentId={(documentItem as any).id}
                          token={token}
                          handleDownload={handleTriggerDownload}
                          uploadsStatus={uploadsStatus}
                        />
                        {/* </Col> */}
                      </Row>
                    </div>
                  </StyledDocumentItem>
                );
              })}
              <span className="orderItemUploadIcons">
                <input
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                  accept="application/pdf"
                  id={'admin_upload_picker' + data._id}
                  type="file"
                  multiple
                  hidden={!isUploadsActive()}
                />
                <label
                  htmlFor={'admin_upload_picker' + data._id}
                  hidden={!isUploadsActive()}>
                  Pridať dokument
                  <PlusCircleOutlined style={{ marginLeft: 15 }} />
                </label>
              </span>
            </Card>
          )}
        </>}
      <OrderStatusModal
        visible={showOrderStatus}
        orderStatus={data.orderStatus ? data.orderStatus : {}}
        handleClose={() => handleStatusModalClose()}
        handleDone={saveOrderStatus}
        orderId={data._id}
        downloads={data.downloads}
      />
    </Card >
  );
}

const mapStateToProps = ({ appState }: { appState: AppState }) => ({
  user: appState.cognitoUser,
});

interface DispatchProps {
  uploadSignedFile: (orderId: string, documentIndex: string, fileData: any) => void;
  saveNote: (note: string, orderId: string) => void;
  saveOrderStatus: (orderId: string, orderStatus: any, changedState: boolean, filesToAttach: string[]) => void;
  fileUpload: (orderId: string, files: FileToUpload[]) => void
  fileDelete: (orderId: string, documentIndex: string) => void
  generateORSRFile: (orderId: string, fileType: ORSRFileTypes) => void
  generateRefund: (orderId: string, refundForm: any) => void
}

function mapDispatchToProps(dispatch: Dispatch<StoreAction, any>): DispatchProps {
  return {
    uploadSignedFile: (orderId: string, documentIndex: string, fileData: any) => dispatch(UploadSignedFileAdminAction(orderId, documentIndex, fileData)),
    saveNote: (note: string, orderId: string) => dispatch(UpdateNoteAction(note, orderId)),
    saveOrderStatus: (orderId: string, orderStatus: any, changedState: boolean, filesToAttach: string[]) =>
      dispatch(UpdateOrderStatusAction(orderId, orderStatus, changedState, filesToAttach)),
    fileUpload: (orderId: string, files: FileToUpload[]) =>
      dispatch(UploadNewDocumentAction(orderId, files)),
    fileDelete: (orderId: string, documentIndex: string) =>
      dispatch(DeleteFileDocumentAction(orderId, documentIndex)),
    generateORSRFile: (orderId: string, fileType: ORSRFileTypes) => dispatch(
      GenerateORSRFileAction(orderId, fileType)),
    generateRefund: (orderId: string, refundForm: any) =>
      dispatch(GenerateRefundAction(orderId, refundForm))
  };
}

type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(OrderItem);
